
<template>
  <v-dialog v-model="show" width="600px">
    <v-card>
      <v-card-title>{{ getTitle }}</v-card-title>
      <v-card-text class="text-xs-center" style="padding: 10px !important">
        {{ getContent }}
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn @click="confirm">承認</v-btn>
        <v-btn @click="cancel">拒否</v-btn>
        <v-btn @click="show = false">戻る</v-btn>
        <v-spacer />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: ['shipmentType'],
  data() {
    return {
      show: false,
      resolve: null,
      reject: null,
      action: null,
    }
  },
  methods: {
    popup({ resolve, reject }) {
      this.show = true
      this.resolve = resolve
      this.reject = reject
    },
    confirm() {
      this.show = false
      this.resolve('ok')
    },
    cancel() {
      this.show = false
      this.reject('cancel')
    },
  },
  computed: {
    getTitle() {
      if (this.shipmentType === 'SA') {
        return '凍結後SA取消'
      }
      if (this.shipmentType === 'FORMALSA') {
        return '凍結後SA一時保存戻し'
      }
      return ''
    },
    getContent() {
      if (this.shipmentType === 'SA') {
        return 'SAP側に買掛金決済済みになる可能性があるので、cancelデータをSAP側に配信すれば、そちら側の処理に問題があるかを事前確認お願い致します。'
      }
      if (this.shipmentType === 'FORMALSA') {
        return '本SAは凍結済みです。事前に関係部署に確認を行った後、承認をお願いいたします。'
      }
      return ''
    },
  },
}
</script>
